// extracted by mini-css-extract-plugin
export default {"wrapper":"PCBForm_wrapper__RRv16","btn":"PCBForm_btn__NTgT+"};